import { render, staticRenderFns } from "./alertPartModalV2.vue?vue&type=template&id=863b8d4a&scoped=true&"
import script from "./alertPartModalV2.vue?vue&type=script&lang=js&"
export * from "./alertPartModalV2.vue?vue&type=script&lang=js&"
import style0 from "./alertPartModalV2.vue?vue&type=style&index=0&id=863b8d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b8d4a",
  null
  
)

export default component.exports